//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'AaGradientAndRatio',
  data() {
    return {
      defaultJson:{
        "rqHint": "呼吸商（Respiratory Quotient, RQ）是 O₂ 摄入与 CO₂ 排出的比值。\n它受饮食变化的影响。进食糖类为 1.0，脂肪为 0.7，蛋白质为 0.9。",
        "PaCO": "PaCO₂",
        "a/A ratio": "a/A 比值",
        "PaO₂": "PaO₂",
        "A-a gradient": "A-a 氧分压差",
        "Atm pressure": "大气压",
        "FiO₂": "FiO₂",
        "RQ": "RQ",
        "PAO₂": "PAO₂"
      },
      form:{
        po2:'',
        pco2:'',
        patm:'760',
        fi:'21',
        rq:'0.8',

      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'男'},
        {value:"5",name:'女'},
      ],
      pAo2:'--',
      aaGradient:'--',
      aaRatio:'--',
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.pAo2='--'
        self.aaGradient='--'
        return '--'
      } else {  
        // 	(fi * (patm - 47)) - (pco2 / rq)
        let pAo2 =  ((form.fi*0.01 * (form.patm - 47)) - (form.pco2 / form.rq))
        self.aaGradient = 	(pAo2 - form.po2).toFixed(0)
        self.aaRatio =	(form.po2 / pAo2).toFixed(2)
        let result = self.aaRatio 
        self.pAo2 = pAo2.toFixed(0)
        
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/AaGradientAndRatio.vue